import { IRadicadoEntradaExtended } from "../../../classes/radicado-entrada-extended";
import { IDocumento } from "../../../ioip/sdk/base";
import { IChoiceGroupOption, IColumn, IContextualMenuItem } from "@fluentui/react";
import { ISuscriptionParameter, defaultISuscriptionParameter } from "../../../classes/iparametro";

export interface IMyPendingWorksComponentState {
    items: IRadicadoEntradaExtended[];
    errors: { [ key: string ]: string };
    Identificacion: string;
    IdTipoIdentificacion: string;
    showAclaracion: boolean;
    IdRadicadoEntradaSelected: number;
    NombreEstadoLineaHonor: string;
    IdEstadoLineaHonor: number,
    EstadoLineaHonor: ISuscriptionParameter,
    HabilitarEstadoEntidadAdscita: ISuscriptionParameter,
    IdUsuario: string,

    data: {
        extensionesPermitiras: string;
    },
    commandBar: IContextualMenuItem[];
    redirectConsultRequest: {
        show: boolean;
        fecha: string;
        url: string;
    },

    ShowPanelEnviarRespuesta: boolean;
    ShowPanelDevolverPqr: boolean;
    ShowPanelCerrarRespuestas: boolean;
    Observaciones: string;
    ObservacionesCierre: string;
    RespuestaDefinitiva: boolean;

    DocumentoPrincipal: IDocumento[];
    Anexos: IDocumento[];

    SelectedItems: IRadicadoEntradaExtended[];
    opcionesRespuestaDefinitiva: IChoiceGroupOption[];
    maxLengthFile: number;
    columns: IColumn[];

    NumeroDocumento: string;
    FechaEnvio?: Date;

    ObservacionesDevolver: string;
}

export function defaultMyPendingWorksComponentState(): IMyPendingWorksComponentState {
    return {
        items: [],
        Identificacion: '',
        IdTipoIdentificacion: '',
        errors: {},
        showAclaracion: false,
        IdRadicadoEntradaSelected: 0,
        NombreEstadoLineaHonor: '',
        IdEstadoLineaHonor: 0,
        EstadoLineaHonor: defaultISuscriptionParameter(),
        HabilitarEstadoEntidadAdscita: defaultISuscriptionParameter(),
        IdUsuario: '',

        data: {
            extensionesPermitiras: 'pdf docx txt xls'
        },
        commandBar: [],
        redirectConsultRequest: {
            show: false,
            fecha: null,
            url: ''
        },

        ShowPanelEnviarRespuesta: false,
        ShowPanelDevolverPqr: false,
        ShowPanelCerrarRespuestas: false,
        Anexos: [],
        DocumentoPrincipal: undefined,
        Observaciones: '',
        ObservacionesCierre: '',
        ObservacionesDevolver: '',
        RespuestaDefinitiva: false,
        SelectedItems: [],
        opcionesRespuestaDefinitiva: [
            {
                key: '0',
                text: 'Respuesta parcial',
            },
            {
                key: '1',
                text: 'Respuesta definitiva',
            }
        ],
        maxLengthFile: 0,
        columns: [
            {
                key: 'Número',
                name: 'Número',
                fieldName: 'NumeroRadicado',
                minWidth: 120,
                maxWidth: 120,
                isResizable: true
            },
            {
                key: 'Tramite',
                name: 'Trámite',
                fieldName: 'Tramite',
                minWidth: 80,
                maxWidth: 100,
                isResizable: true
            },
            {
                key: 'Clasificación',
                name: 'Clasificación',
                fieldName: 'ClasificacionPQRS',
                minWidth: 100,
                maxWidth: 110,
                isResizable: true,
                isSorted: false
            },
            {
                key: 'FechaCreacionString2',
                name: 'Fecha de creación',
                fieldName: 'FechaCreacionString2',
                minWidth: 120,
                maxWidth: 120,
                isSorted: false,
                isResizable: true
            },
            {
                key: 'Asunto',
                name: 'Asunto',
                fieldName: 'Asunto',
                isMultiline: true,
                maxWidth: 150,
                minWidth: 130,
                isResizable: true
            },
            {
                key: 'NombreEntidadAdscrita',
                name: 'Entidad',
                fieldName: 'NombreEntidadAdscrita',
                maxWidth: 150,
                minWidth: 120,
                isResizable: true
            },
            {
                key: 'CorreoElectronicoContacto',
                name: 'Correo contacto',
                fieldName: 'CorreoElectronicoContacto',
                maxWidth: 250,
                minWidth: 200,
                isResizable: true
            },
            {
                key: 'TiempoMaximoRespuestaString',
                name: 'Fecha maxima de respuesta',
                fieldName: 'TiempoMaximoRespuestaString',
                maxWidth: 170,
                minWidth: 150,
                isResizable: true
            }
        ],
        NumeroDocumento: '',
        FechaEnvio: null
    };
}